export default __webpack_public_path__ + "static/media/logo-AiVoice-new.b6ba42c5.svg";